<template>
  <div class="card bg-base-100 shadow-md">
    <div class="card-body p-4">
      <h2 class="card-title text-lg">1.0 업데이트</h2>
      <ul class="list-disc list-inside text-sm leading-6">
        <li>독채팅(Beta) 추가</li>
        <li>업로드 중단 채널 탭 분리</li>
        <li>UI 이미지 교체</li>
        <li>하단 공지 업데이트</li>
      </ul>
    </div>
  </div>
</template>
<script setup></script>
